import { ObendyRoute } from '@core/app-routing';
import { ConnectedRoutesGuards } from '@core/guards/connected-routes.guard';
import { CommunicationsResolver } from '@features/dashboard/resolvers/communications.resolver';
import { DashboardPageResolver } from '@features/dashboard/resolvers/dashboard-page.resolver';
import { PlanRenewBannerMessageResolver } from '@features/dashboard/resolvers/plan-renew-banner-message.resolver';
import { ShowCallToActionCardResolver } from '@features/dashboard/resolvers/show-call-to-action.resolver';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';

export const DASHBOARD_ROUTE: ObendyRoute = {
  path: FeaturesRoutingEnum.Dashboard,
  title: 'Accueil',
  canActivate: ConnectedRoutesGuards,
  showInSiteMap: true,
  loadComponent: () =>
    import('@features/dashboard/dashboard/dashboard.component').then((cmp) => cmp.DashboardComponent),
  data: {
    showBreadcrumb: false,
    pageWithIncentiveBanner: true,
  },
  resolve: {
    showCallToActionCard: ShowCallToActionCardResolver,
    dashboardPage: DashboardPageResolver,
    communications: CommunicationsResolver,
    planRenewMessage: PlanRenewBannerMessageResolver,
  },
};
